import styled, { css } from 'styled-components';
import { useRouter } from 'next/router';
import { H2, SubtitleL, BB, BBINDIGO } from 'global-styles';
import overviewImg from 'public/asset/about/01-section1/section1-img.png';
import { txtAnimation } from 'components/Home/BannerItems';
import { opacityAppear } from 'components/Home/ProductTemplate';
import Image from 'next/image';

const KoDesc = () => (
  <>
    <div className="XlL">
      <OverviewSubtitle>
        블루닷은 저지연 라이브 스트리밍, 비디오 컨텐츠 프로덕션, 그리고 컴퓨터
        비전 애플리케이션에
      </OverviewSubtitle>
      <OverviewSubtitle>
        필요한
        <span> 고성능 인코딩, 화질 개선 및 인지화질 최적화 솔루션</span>을
        제공하고 있습니다.
      </OverviewSubtitle>
    </div>
    <div className="MS">
      <OverviewSubtitle>
        블루닷은 저지연 라이브 스트리밍, 비디오 컨텐츠 프로덕션,
      </OverviewSubtitle>
      <OverviewSubtitle>
        그리고 컴퓨터 비전 애플리케이션에 필요한 <span>고성능</span>
      </OverviewSubtitle>
      <OverviewSubtitle>
        <span>인코딩, 화질 개선 및 인지화질 최적화 솔루션</span>을 제공하고
        있습니다.
      </OverviewSubtitle>
    </div>
    <div className="XS">
      <OverviewSubtitle>
        블루닷은 저지연 라이브 스트리밍, 비디오 컨텐츠
      </OverviewSubtitle>
      <OverviewSubtitle>
        프로덕션, 그리고 컴퓨터 비전 애플리케이션에
      </OverviewSubtitle>
      <OverviewSubtitle>
        필요한 <span>고성능 인코딩, 화질 개선 및 인지화질</span>
      </OverviewSubtitle>
      <OverviewSubtitle>
        <span>최적화 솔루션</span>을 제공하고 있습니다.
      </OverviewSubtitle>
    </div>
  </>
);

const EnDesc = () => (
  <>
    <div className="XlL">
      <OverviewSubtitle>
        BLUEDOT provides
        <span> High Performance Encoding, Video Quality Improvement </span>
        and
      </OverviewSubtitle>
      <OverviewSubtitle>
        <span>Perceptual Quality Optimization </span>
        for low latency live streaming, video production,
      </OverviewSubtitle>
      <OverviewSubtitle>and computer vision applications.</OverviewSubtitle>
    </div>

    <div className="MS">
      <OverviewSubtitle>
        BLUEDOT provides
        <span> High Performance Encoding, Video</span>
      </OverviewSubtitle>
      <OverviewSubtitle>
        <span>Quality Improvement </span>
        and
        <span> Perceptual Quality Optimization for</span>
      </OverviewSubtitle>
      <OverviewSubtitle>
        low latency live streaming, video production, and computer
      </OverviewSubtitle>
      <OverviewSubtitle>vision applications.</OverviewSubtitle>
    </div>

    <div className="XS">
      <OverviewSubtitle>
        BLUEDOT provides
        <span> High Performance</span>
      </OverviewSubtitle>
      <OverviewSubtitle>
        <span>Encoding, Video Quality Improvement</span>
      </OverviewSubtitle>
      <OverviewSubtitle>and Perceptual Quality Optimization</OverviewSubtitle>
      <OverviewSubtitle>for low latency live streaming</OverviewSubtitle>
      <OverviewSubtitle>video production, and computer vision</OverviewSubtitle>
      <OverviewSubtitle>applications.</OverviewSubtitle>
    </div>
  </>
);

interface Props {
  isVisible: boolean;
  // targetRef: MutableRefObject<HTMLElement>;
  targetRef: (node?: Element) => void;
}

export const Overview = ({ isVisible, targetRef }: Props) => {
  const { locale } = useRouter();

  return (
    <OverViewContainer ref={targetRef} isVisible={isVisible}>
      <H2 className="overview-title">Overview</H2>
      <div className="overview-inner-container">
        <div className="overview-img-wrapper">
          <Image
            src={overviewImg.src}
            quality={100}
            width="180px"
            height="100px"
            layout="responsive"
            objectFit="contain"
            alt="BLUEDOT provides High Performance Encoding, Video Quality Improvement and Perceptual Quality Optimization for low latency live streaming, video production, and computer vision applications."
          />
        </div>

        <div className="overview-desc-text">
          {locale === 'en' ? <EnDesc /> : <KoDesc />}
        </div>
      </div>
    </OverViewContainer>
  );
};

const OverviewSubtitle = styled(SubtitleL)`
  span {
    color: ${BB};
  }
`;

const OverViewContainer = styled.section`
  .XS,
  .MS {
    display: none;
  }

  .overview-title {
    text-align: center;
    opacity: 0;
  }
  @media screen and (min-width: 1440px) {
    margin: 192px 0 146px;
    .overview-title {
      margin-bottom: 56px;
    }
  }
  @media screen and (min-width: 1240px) and (max-width: 1439px) {
    margin: 192px 0 146px;
    .overview-title {
      margin-bottom: 32px;
    }
  }
  @media screen and (min-width: 905px) and (max-width: 1239px) {
    .XlL {
      display: none;
    }
    .MS {
      display: block;
    }
    margin: 146px 0 96px;
    .overview-title {
      margin-bottom: 32px;
    }
  }
  @media screen and (min-width: 600px) and (max-width: 904px) {
    margin: 96px 0 56px;
    .XlL {
      display: none;
    }
    .MS {
      display: block;
    }
    .overview-title {
      margin-bottom: 16px;
    }
  }
  @media screen and (max-width: 599px) {
    margin: 56px 0 32px;
    .XlL,
    .MS {
      display: none;
    }
    .XS {
      display: block;
    }
    .overview-title {
      margin-bottom: 16px;
    }
  }
  .overview-inner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: ${BBINDIGO};
  }
  .overview-img-wrapper {
    position: relative;
    object-fit: contain;
    width: 100vw;
    opacity: 0;
    max-width: 1240px;
    margin-bottom: 32px;
    @media screen and (max-width: 904px) {
      margin-bottom: 16px;
    }
  }
  .overview-desc-text {
    width: 100%;
    text-align: center;
    padding: 0 15px;
    overflow-y: hidden;
    opacity: 0;
  }
  ${({ isVisible }: { isVisible: boolean }) =>
    isVisible &&
    css`
      .overview-title {
        animation: ${txtAnimation} 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
      }
      .overview-img-wrapper {
        animation: ${opacityAppear} 0.8s 0.2s cubic-bezier(0.4, 0, 0.2, 1)
          forwards;
      }
      .overview-desc-text {
        animation: ${txtAnimation} 1.2s 0.4s cubic-bezier(0.4, 0, 0.2, 1)
          forwards;
      }
    `};
`;
